import { useSyncExternalStore } from 'react';
import { isIos, isStandalone } from './notify-platform';

/**
 * AZ APP TELEPITESE (K2).
 *
 * Telepitve az AVSlack sajat ikonnal indul, teljes kepernyon, es iPhone-on
 * CSAK igy kap push-ertesitest. Eddig ezt senki nem mondta meg: aki nem
 * ismerte a bongeszo menujet, bongeszoben hasznalta, ertesites nelkul.
 *
 *  - Androidon / Chrome-ban a bongeszo `beforeinstallprompt` esemenyt kuld -
 *    ezt eltesszuk, es a sajat "Telepites" gombunk ezzel nyitja a rendszer
 *    parbeszedet.
 *  - iPhone-on nincs ilyen: ott a Megosztas -> "Fo kepernyore" lepest kell
 *    elmondani.
 *
 * Az esemeny nagyon koran jon, meg a React elott - ezert az elkapast a
 * `main.tsx` inditja (`captureInstallPrompt`).
 */

interface BeforeInstallPromptEvent extends Event {
  prompt: () => Promise<void>;
  userChoice: Promise<{ outcome: 'accepted' | 'dismissed' }>;
}

let deferred: BeforeInstallPromptEvent | null = null;
let installed = false;
const listeners = new Set<() => void>();
const notify = () => listeners.forEach((listener) => listener());

export function captureInstallPrompt(): void {
  if (typeof window === 'undefined') return;
  window.addEventListener('beforeinstallprompt', (event) => {
    // A bongeszo sajat mini-savja helyett a mi gombunk kinalja fel.
    event.preventDefault();
    deferred = event as BeforeInstallPromptEvent;
    notify();
  });
  window.addEventListener('appinstalled', () => {
    deferred = null;
    installed = true;
    notify();
  });
}

/** Hogyan telepitheto most: rendszer-parbeszeddel, kezi lepesekkel (iOS), vagy sehogy. */
export type InstallMode = 'prompt' | 'ios' | null;

function currentMode(): InstallMode {
  if (installed || isStandalone()) return null;
  if (deferred) return 'prompt';
  if (isIos()) return 'ios';
  return null;
}

export function useInstallMode(): InstallMode {
  return useSyncExternalStore(
    (listener) => {
      listeners.add(listener);
      return () => listeners.delete(listener);
    },
    currentMode,
    () => null,
  );
}

/** A rendszer telepito parbeszede. Igaz, ha a felhasznalo telepitette. */
export async function promptInstall(): Promise<boolean> {
  const event = deferred;
  if (!event) return false;
  // Egy esemeny egyszer hasznalhato.
  deferred = null;
  notify();
  await event.prompt();
  const choice = await event.userChoice;
  return choice.outcome === 'accepted';
}
